import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'examination',
  templateUrl: './examination.component.html',
  styleUrls: ['./examination.component.sass']
})
export class ExaminationComponent implements OnInit {

  constructor() { }

  showEco:boolean;
  showZys:boolean;

  ngOnInit() {
  }
}
